import { render } from "./Roles.vue?vue&type=template&id=55f735be&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=55f735be&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-55f735be"

export default script